import cloneDeep from 'lodash/cloneDeep';

import api from './api';

const authHeaderNames = [
  'access-token',
  'token-type',
  'expiry',
  'client',
  'uid'
];

export const getAuthHeaders = () => {
  const headers = {};

  authHeaderNames.forEach(name => {
    const token = localStorage.getItem(name);

    if (token) {
      headers[name] = token;
    }
  });

  return headers;
};

export const setAuthHeaders = headers => {
  authHeaderNames.forEach(name => {
    const token = headers[name];

    if (token) {
      const backendHeaders = cloneDeep(api.backend.defaults.headers);
      backendHeaders.common[name] = headers[name];
      api.backend.defaults.headers = backendHeaders;

      localStorage.setItem(name, headers[name]);
    }
  });
};

export const removeAuthHeaders = () => {
  authHeaderNames.forEach(name => {
    delete api.backend.defaults.headers.common[name];
    localStorage.removeItem(name);
  });
};



// WEBPACK FOOTER //
// ./src/helpers/auth.js